import React from 'react';

import BannerItemText from '../BannerItemText';

import styles from './index.module.scss';

export enum TextBoxBackgroundColor {
  GRADIENT_WHITE = 'gradientWhite',
  RED = 'red',
  GREEN = 'green'
}

type TextBoxColor =
  | TextBoxBackgroundColor.GRADIENT_WHITE
  | TextBoxBackgroundColor.RED
  | TextBoxBackgroundColor.GREEN;

const TextBoxColorMap: Record<TextBoxColor, string> = {
  [TextBoxBackgroundColor.GRADIENT_WHITE]:
    'linear-gradient(261deg, #b7b7b766 0.97%, #86868657 94.26%)',
  [TextBoxBackgroundColor.RED]: 'rgba(200, 88, 95, 0.62)',
  [TextBoxBackgroundColor.GREEN]: '#B6BD4D'
};

interface BannerWithTextBoxProps {
  image: string;
  text: string;
  backgroundColor?: TextBoxColor;
}

const BannerWithTextBox: React.FC<BannerWithTextBoxProps> = ({
  image,
  text,
  backgroundColor = TextBoxBackgroundColor.GRADIENT_WHITE
}) => {
  return (
    <div className={styles.wrapper}>
      <img src={image} alt='Banner' className={styles.image}/>
      <div
        className={styles.textBox}
        style={{ background: TextBoxColorMap[backgroundColor] }}
      >
        <BannerItemText text={text}/>
      </div>
    </div>
  );
};

export default BannerWithTextBox;
